import { render, staticRenderFns } from "./StaffActive.vue?vue&type=template&id=7fb88f87&"
import script from "./StaffActive.vue?vue&type=script&lang=js&"
export * from "./StaffActive.vue?vue&type=script&lang=js&"
import style0 from "./StaffActive.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports